import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  useState,
  useEffect,
  useRef,
} from 'react';

import { useTownAssets } from '../../stores';
import { logError } from '../../utils';

function SecuredSpanImg({
  piid,
  urlPath,
  className,
  style,
  alt,
  version,
}) {
  const { assets } = useTownAssets();
  const {
    getSecuredImg,
    flushSecuredImg,
  } = assets;

  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const prevVersionRef = useRef(undefined);

  useEffect(
    () => {
      if ((version !== undefined)
          && (version !== null)
          && (prevVersionRef.current !== undefined) && (prevVersionRef.current !== null)
          && (version !== prevVersionRef.current)) {
        flushSecuredImg(urlPath, piid);
      }

      prevVersionRef.current = version;
    },
    [version, urlPath, piid, flushSecuredImg],
  );

  useEffect(
    () => {
      const fetchImage = async () => {
        setLoading(true);
        setError(false);

        const img = await getSecuredImg(urlPath, piid);

        if (img) {
          setImageSrc(img);
        } else {
          logError(
            `Failed getSecuredImg urlPath=${urlPath}, piid=${piid}`,
            'SecuredSpanImg.getSecuredImg.failed',
            { urlPath, piid, version },
          );
          setError(true);
        }
        setLoading(false);
      };

      // Use void to make it clear we do not want to wait this async function:
      void fetchImage();
    },
    [piid, getSecuredImg, urlPath, version],
  );

  if (loading) {
    return (
      <span className={classNames('inline-block', className)} style={style}>
        ...
      </span>
    );
  }

  if (error) {
    return (
      <span className={classNames('inline-block', className)} style={style}>
        {alt}
      </span>
    );
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
      style={style}
    />
  );
}

SecuredSpanImg.propTypes = {
  piid: PropTypes.string,
  urlPath: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  alt: PropTypes.string,
  version: PropTypes.number,
};

export default SecuredSpanImg;
